import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';

export default function LoginPage() {
  const { user, login } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (user) {
    const from = location.state?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      // useAuth's setUser → component re-renders → <Navigate> above kicks in.
    } catch (err) {
      setError(err.status === 401 ? 'Invalid email or password.' : 'Something went wrong. Try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm space-y-4 rounded-2xl border border-slate-800 bg-slate-900/60 p-8 shadow-xl backdrop-blur"
      >
        <header>
          <h1 className="text-2xl font-semibold tracking-tight text-brand-500">hunter</h1>
          <p className="mt-1 text-sm text-slate-400">Job Search OS · sign in</p>
        </header>

        <label htmlFor="login-email" className="block">
          <span className="text-xs uppercase tracking-wide text-slate-400">Email</span>
          <input
            id="login-email"
            type="email"
            autoComplete="email"
            required
            aria-invalid={!!error}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-md border border-slate-700 bg-slate-950/40 px-3 py-2 text-sm text-slate-100 focus:border-brand-500 focus:outline-none"
          />
        </label>

        <label htmlFor="login-password" className="block">
          <span className="text-xs uppercase tracking-wide text-slate-400">Password</span>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            required
            aria-invalid={!!error}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-md border border-slate-700 bg-slate-950/40 px-3 py-2 text-sm text-slate-100 focus:border-brand-500 focus:outline-none"
          />
        </label>

        {error && (
          <p role="alert" className="text-sm text-red-400">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-md bg-brand-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-brand-500 disabled:opacity-50"
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="text-center text-xs text-slate-500">
          No public signup. Seed a user via the <code className="font-mono">createUser.js</code> CLI.
        </p>
      </form>
    </main>
  );
}
